import * as React from 'react';
import { useSelector } from 'react-redux';

import { AboutServicePresentationSection } from '../../components/AboutServicePresentationSection';
import { trackAboutServicePresentationClick } from './tracking';
import { selectServicePresentationUrl } from '../../selectors/promoInfo';

/**
 * Секция "Расскажите своим клиентам о сервисе".
 */
export const AboutServicePresentationSectionContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const url = useSelector(selectServicePresentationUrl);

  return <AboutServicePresentationSection url={url} onDownloadClick={trackAboutServicePresentationClick} />;
};
